import { render, staticRenderFns } from "./PsTopBar.vue?vue&type=template&id=9188296c&scoped=true&"
import script from "./PsTopBar.vue?vue&type=script&lang=js&"
export * from "./PsTopBar.vue?vue&type=script&lang=js&"
import style0 from "./PsTopBar.vue?vue&type=style&index=0&id=9188296c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9188296c",
  null
  
)

export default component.exports